import Vue from 'vue';
import { handleCheckInfo } from './permission';
export const sizeMixin = Vue.extend({
    inject: {
        $xeSizeInfo: {
            default: null
        }
    },
    provide() {
        return {
            $xeSizeInfo: {
                getSize: () => this.computeSize
            }
        };
    },
    computed: {
        computeSize() {
            const { size } = this;
            const $xeSizeInfo = this.$xeSizeInfo;
            return size || ($xeSizeInfo ? $xeSizeInfo.getSize() : null);
        }
    }
});
export const permissionMixin = Vue.extend({
    computed: {
        computePermissionInfo() {
            return handleCheckInfo(this.permissionCode, this.permissionMethod);
        }
    }
});
export const globalMixins = {
    sizeMixin,
    permissionMixin
};
